<div class="app-content content" *ngIf="detallesPostulante && datosPostulante">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-body">
        <section id="user-feed">
          <div class="row">
            <div class="col-12">
              <img src="https://res.cloudinary.com/drtcnv1st/image/upload/v1678233095/Graduados/bg-portada-eg_ydvfr1.png" class="img-fluid rounded" alt="timeline image">
              <div class="user-data text-center bg-white rounded pb-2 mb-md-2">
                <img *ngIf="detallesPostulante?.imgUrl" [src]="'https://res.cloudinary.com/drtcnv1st/image/upload/v1678298916/Graduados/'+detallesPostulante?.imgUrl"
                  class="img-fluid rounded-circle width-150 profile-image shadow-lg border border-3" alt="timeline image">
                <img *ngIf="!detallesPostulante?.imgUrl" [src]="'https://res.cloudinary.com/drtcnv1st/image/upload/v1677881047/Graduados/No_image_available.svg_xvejcl.png'"
                  class="img-fluid rounded-circle width-150 profile-image shadow-lg border border-3" alt="timeline image">
                <h4 class="mt-1 mb-1 font-medium-5 text-bold-500">{{datosPostulante.nombre + ' '+datosPostulante.apellido}}</h4>
                <h5 class="m-0 font-medium-3 text-bold-400">{{datosPostulante.edad}} años</h5>
                <br>
                <nav class="navbar">
                  <ul class="navbar-nav mr-auto">
                    <li>
                      <h5 class="text-bold-500 secondary">Fecha de postulación: {{convertDate(datosPostulante.fechaPostulacion)}}</h5>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card shadow-none">
                <div class="row" matchHeight="card">
                  <div class="col-lg-12 col-md-12">
                    <div class="card">
                      <div class="card-header">
                        <h4 class="card-title font-medium-3">Habilidades socioemocionales</h4>
                      </div>
                      <div class="card-content collapse show">
                        <div class="card-body" *ngIf="detallesPostulante?.habilidades;">
                          <ul class="list-group" *ngFor="let habilidad of detallesPostulante?.habilidades; let i = index;">
                            <li class="list-group-item list-group-item-action list-group-item-success">
                              <span class="float-left">
                                <i class="la la-diamond mr-1"></i>
                              </span>
                              <span class="badge badge-info badge-pill float-right">
                                {{i+1}}
                              </span >
                              {{habilidad.descripcion}}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="col-md-12" *blockUI="'userProfile'; message: 'Loading'">
                <m-card [options]="options" >
                  <ng-container mCardHeaderTitle >
                    <h4 class="card-title font-medium-3">Acerca de mí</h4>
                  </ng-container>
                  <ng-container mCardBody>
                    <div class="text-bold-800">
                      <p><b><blockquote>&#34;{{datosPostulante.descripcionEgresado}}&#34;</blockquote></b></p>
                    </div>
                    <form>
                      <div class="form-body">
                        <h4 class="form-section text-bold-500"><i class="feather ft-github blue4"></i>Información básica</h4>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="nombreInput">Nombre</label>
                              <input type="text" id="nombreInput" readonly disabled [value]="datosPostulante?.nombre+' '+datosPostulante?.apellido" class="form-control">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="areaInput">Área</label>
                              <input type="text" id="areaInput" readonly disabled [value]="datosPostulante.area" class="form-control">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="especialidadInput">Especialidad</label>
                              <input type="text" id="especialidadInput" readonly disabled [value]="datosPostulante.division" class="form-control">
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
  
                    <div class="card bg-info bg-lighten-4" *ngIf="!hasPostulacion">
                      <div class="card-body">
                        <a [routerLink]="">
                          <h6 class="card-title font-medium-1 text-white">
                            Sea cuál sea el resultado, gracias por la consideración.
                          </h6>
                        </a>
                        <div class="parent">
                          <div class="row">
                            <div class="col-md-auto">
                              <button class="btn btn-info btn-lg" (click)="onReject()" type="button">
                                <h5 class="text-uppercase white text-bold-600">Descartar</h5></button>
                            </div>
                            <div class="col-md-auto">
                              <button class="btn btn-warning btn-lg" (click)="onSuccess()" type="button">
                                <h5 class="text-uppercase white text-bold-600">Contactar</h5></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </m-card>
  
                <div class="card shadow-none">
                  <div class="card-body">
                    <h4 class="card-title font-medium-3">Experiencia laboral</h4>
                    <hr>
                    <div>
                      <div class="list-group-item bg-gradient-x-primary flex-column align-items-start">
                        <div class="d-flex w-100 justify-content-between">
                          <h5 class="text-bold-600 white">Esperando formar parte de tu equipo de trabajo</h5>
                        </div>
                        <small class="text-white">Contactame hoy mismo.</small>
                      </div>
                      <div *ngFor="let experiencia of detallesPostulante?.experiencias; let i = index;">
                        <div class="list-group-item bs-callout-primary border-none flex-column align-items-start">
                          <div class="d-flex w-100 justify-content-between">
                            <h5 class="text-bold-600 dark">{{experiencia.empresa}}</h5>
                          </div>
                          <p >{{experiencia.cargo}}</p>
                          <small>Periodo: {{experiencia.periodo}}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-12 col-sm-12">
              <div class="card text-white bg-gradient-x-warning mb-3">
                <div class="card-header">
                  <h3><i class="icon-pin text-white"></i></h3>
                </div>
                <div class="card-body pt-0">
                  <h3 class="white">¡Quiero trabajar!</h3>
                  <p class="card-text">"Contrata a alguien que te inspire confianza, porque la confianza es la base de cualquier relación exitosa."</p>
                </div>
              </div>
  
              <div class="card shadow-none mt-2">
                <div class="row" matchHeight="card">
                  <div class="col-lg-12 col-md-12">
                    <div class="card">
                      <div class="card-header">
                        <h4 class="card-title font-medium-3">Habilidades técnicas</h4>
                      </div>
                      <div class="card-content collapse show">
                        <div class="card-body" *ngIf="detallesPostulante?.conocimientos">
                          <ul class="list-group" *ngFor="let conocimiento of detallesPostulante?.conocimientos; let i = index;">
                            <li class="list-group-item list-group-item-action list-group-item-info">
                              <span class="float-left">
                                <i class="la la-star mr-1"></i>
                              </span>
                              <span class="badge badge-primary badge-pill float-right">
                                {{i+1}}
                              </span>
                              {{conocimiento.descripcion}}
                            </li>                          
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
